import {useContext} from "react";
import {RouteContext} from "./context";
import {useLocation} from "react-router-dom";

function useAuth(): String[] {
    const context = useContext(RouteContext)
    return context?.resources || []
}

export default useAuth
